import {colors} from '@purpose/ui/styles/theme/colors';

export const style = {
  toastContainer: {
    background: 'transparent',
    border: 'none',
    borderRadius: '16px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
  },
  toast: {
    boxShadow: '0px 4px 14px 0px rgba(200, 200, 200, 0.24)',
    backdropFilter: 'blur(8px)',
    px: '16px',
    py: '12px',
    borderRadius: '16px'
  }
};

export const layoutByState = {
  error: {
    backgroundColor: colors.toast.red,
    color: colors.white
  },
  success: {
    backgroundColor: colors.toast.green,
    color: colors.white
  }
};
